export let ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["Short"] = "short";
  ProductType["Parcours"] = "parcours";
  ProductType["Uc"] = "courseUnit";
  return ProductType;
}({});